var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"rp-title"},[_vm._v("Daily Report")]),_c('div',{staticClass:"rp-header-wrapper"},[_c('div',{staticClass:"rp-header-left"},[_c('h4',[_vm._v("Vessel: "+_vm._s(_vm.massName))]),_c('div',{staticClass:"rp-info-date"},[_vm._v("Analyzed data: "+_vm._s(_vm.start)+" to "+_vm._s(_vm.end)+" GMT +007")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }